export enum DealsGroupByType {
  USER = "USER",
  TEAM = "TEAM",
  FUNNEL = "FUNNEL",
}
